import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  getAccessorySequence,
  getMonitorPatientParameters,
} from 'redux/reducers';
import {
  PartsCollection
} from 'models/Part';

import FilterSelection from './FilterSelection';

import './FilterSequence.css';
import connect from 'react-redux/es/connect/connect';

class FilterSequence extends Component {
  constructor(props) {
    super(props);

    // first filter needs to stay closed
    this.startSelectOpen = false;
  }

  componentDidMount() {
    // setup filter choice units
    // set filter sequence from monitor
    const { monitor, partsCollection, filterChoices } = this.props;
    if (!filterChoices) {
      const newFilterChoices = new Map();

      // setup the main 4 filters
      const filters = partsCollection.filterSequence;

      // determine default options for patient parameter by looking at parts that fit this monitor
      filters.forEach((filterTag, idx, arr) => {
        newFilterChoices.set(filterTag, {
          defaultOptions: filterTag === 'patientParameter'
            ? partsCollection.findAllowedPatientParameters(getMonitorPatientParameters(monitor))
            : null,
          optionsLabels: null,
          choice: '',
          skip: false,
          prevTag: idx > 0 ? arr[idx - 1] : null,
          nextTag: idx + 1 < arr.length ? arr[idx + 1] : null
        });
      });
      const { onFilterChoicesChanged } = this.props;
      onFilterChoicesChanged(newFilterChoices);

      console.log('FilterSequence, parts:', partsCollection);
    }
  }

  gatherFilterOptionsLabels(filterChoices, filterTag) {
    const filterChoice = filterChoices.get(filterTag);
    if (!filterChoice) {
      return [];
    }
    const { defaultOptions } = filterChoice;
    if (defaultOptions) {
      return defaultOptions;
    }
    if (filterChoice.optionsLabels) {
      return filterChoice.optionsLabels;
    }

    const { monitor } = this.props;
    const accessorySequence = getAccessorySequence(monitor, filterChoices);
    // TODO - need to merge all sequences

    // Get filter choices that are allowed for the specified filter based on past choices
    const { partsCollection } = this.props;
    if (filterTag === 'parameterOption') {
      const patientParameter = filterChoices.get('patientParameter').choice;
      return partsCollection.findAllowedParameterOptions(
        accessorySequence,
        monitor.inclusions ? monitor.inclusions[patientParameter] : null
      );
    }
    if (filterTag === 'patientCategory') {
      // Get the patient categories that are allowed at this point
      return partsCollection.findAllowedPatientCategories(accessorySequence);
    }
    if (filterTag === 'usageCategory') {
      return partsCollection.findAllowedUsageCategories(accessorySequence);
    }

    return [];
  }

  saveFilterChoice(filterChoices, filterTag, option) {
    const filterChoice = filterChoices.get(filterTag);
    filterChoice.choice = option;

    // cull chosen parts based on the new choice
    const { partsCollection } = this.props;
    partsCollection[filterTag] = option;
    return filterChoices;
  }

  solveFilterChoices(filterChoices, filterTag) {
    if (!filterTag) {
      return filterChoices;
    }
    const filterChoice = filterChoices.get(filterTag);
    const optionsLabels = this.gatherFilterOptionsLabels(
      filterChoices,
      filterTag
    );
    filterChoice.optionsLabels = optionsLabels;

    // if no options at all, this needs to be skipped
    /* OLD WAY - need verification
    filterChoice.skip = optionsLabels.length === 0
      || (optionsLabels.length === 1 && filterTag === 'parameterOption');
    */
    filterChoice.skip = optionsLabels.length <= 1;

    // only one choice, choose it now
    if (optionsLabels.length === 1 || filterChoice.skip) {
      this.saveFilterChoice(filterChoices, filterTag, filterChoice.skip ? '' : optionsLabels[0]);
      return this.solveFilterChoices(filterChoices, filterChoice.nextTag);
    }

    return filterChoices;
  }

  onSelectFilter = (filterTag, option) => {
    const { filterChoices } = this.props;

    // Save filter choice, and cascade the choice through subsequent filters
    const newFilterChoices = new Map(filterChoices);
    if (option === '') {
      // clear filters from here forward
      const entriesIt = newFilterChoices.entries();
      let entry = entriesIt.next();
      let clear = false;
      while (!entry.done) {
        if (clear || entry.value[0] === filterTag) {
          const filterChoice = entry.value[1];
          filterChoice.choice = '';
          filterChoice.skip = false;
          if (clear) {
            filterChoice.optionsLabels = null;
          }
          clear = true;
        }
        entry = entriesIt.next();
      }
    } else {
      this.saveFilterChoice(newFilterChoices, filterTag, option);
      this.solveFilterChoices(newFilterChoices, filterChoices.get(filterTag).nextTag);
    }

    const { onFilterChoicesChanged } = this.props;
    onFilterChoicesChanged(newFilterChoices);
  };

  onDropFilter = (filterTag) => {
    // clear the value of this dropdown and all subsequent choices
    this.onSelectFilter(filterTag, '');
    this.startSelectOpen = true;
  };

  renderFilter(filterTag) {
    const { filterChoices } = this.props;
    const filterChoice = filterChoices.get(filterTag);
    if (!filterChoice || filterChoice.skip || this.isFilterChoiceEmpty(filterChoice.prevTag)) {
      return null;
    }
    return (
      <div key={filterTag} className="col-md-6 col-sm-12">
        <FilterSelection
          filterTag={filterTag}
          onDrop={this.onDropFilter}
          onSelect={this.onSelectFilter}
          options={this.gatherFilterOptionsLabels(filterChoices, filterTag)}
          startOpen={filterTag !== 'patientParameter' || this.startSelectOpen}
          value={filterChoice.choice}
        />
      </div>
    );
  }

  isFilterChoiceEmpty(filterTag) {
    if (!filterTag) {
      return false;
    }
    const { filterChoices } = this.props;
    return filterChoices.get(filterTag).choice === '' && !filterChoices.get(filterTag).skip;
  }

  render() {
    const { filterChoices, getString } = this.props;
    return (
      <div className="blue-block">
        <h2 className="block-head">
          <span className="number">
            2
          </span>
          <span>
            {getString('filters', 'general')}
          </span>
        </h2>
        <div className="row">
          {
            filterChoices
            && Array.from(filterChoices.keys()).map(filterTag => this.renderFilter(filterTag))
          }
        </div>
      </div>
    );
  }
}

FilterSequence.defaultProps = {
  filterChoices: null
};
FilterSequence.propTypes = {
  filterChoices: PropTypes.instanceOf(Map),
  monitor: PropTypes.shape().isRequired,
  onFilterChoicesChanged: PropTypes.func.isRequired,
  partsCollection: PropTypes.instanceOf(PartsCollection).isRequired,
  getString: PropTypes.func.isRequired,
};

export default connect(
  state => ({
    getString: state.strings.getString
  }),
)(FilterSequence);
